export default __webpack_public_path__ + "static/media/BSHARE.c7130807.png";